import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'platform/forms/components/common/grid';
import PreSubmitSection from 'platform/forms/components/review/PreSubmitSection';
import ProgressButton from '../../components/ProgressButton';
import Back from './Back';

export default function Submitted(props) {
  const { formConfig, onBack, onSubmit } = props;
  let ariaDescribedBy = null;
  // If no ariaDescribedBy is passed down from form.js,
  // a null value will properly not render the aria label.
  if (formConfig?.ariaDescribedBySubmit !== null) {
    ariaDescribedBy = formConfig?.ariaDescribedBySubmit;
  } else {
    ariaDescribedBy = null;
  }
  const hideBackButton = formConfig?.useTopBackLink || false;
  const useWebComponents =
    formConfig?.formOptions?.useWebComponentForNavigation;

  return (
    <>
      <PreSubmitSection formConfig={formConfig} />
      <Row classNames="form-progress-buttons vads-u-margin-y--2">
        {hideBackButton ? (
          <Column classNames="small-6 medium-5">
            <ProgressButton
              ariaDescribedBy={ariaDescribedBy}
              onButtonClick={onSubmit}
              buttonText="Submitted"
              disabled
              buttonClass=""
              beforeText="&#10003;"
              useWebComponents={useWebComponents}
            />
          </Column>
        ) : (
          <>
            <Column classNames="small-6 medium-5">
              <Back
                onButtonClick={onBack}
                useWebComponents={useWebComponents}
              />
            </Column>
            <Column classNames="small-6 medium-5">
              <ProgressButton
                ariaDescribedBy={ariaDescribedBy}
                onButtonClick={onSubmit}
                buttonText="Submitted"
                disabled
                buttonClass=""
                beforeText="&#10003;"
                useWebComponents={useWebComponents}
              />
            </Column>
            <Column classNames="small-1 medium-1 end">
              <div className="hidden">&nbsp;</div>
            </Column>
          </>
        )}
      </Row>
    </>
  );
}

Submitted.propTypes = {
  formConfig: PropTypes.object,
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
};
